import { useState } from "react"
import "./carousel.css"
import CurrencyFormat from "react-currency-format"
import { useGlobalContext } from "../../context";
import Detailpro from "../detailpro/detailpro";
import { Link } from "react-router-dom"

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
function Carousel1(props) {
    const { handleShowDetail, setSize, setShowdetail, setQtyInStore } = useGlobalContext()
    const [changeImage, setChangeImage] = useState(null)
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        res: {
            breakpoint: { max: 3000, min: 1050 },
            items: 4
        },
        desktop: {
            breakpoint: { max: 1049, min: 671 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 670, min: 320 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 320, min: 0 },
            items: 1
        }
    };
    return (
        <div className="carousel">
            <div className="carousel-title">
                <h2>{props.title}</h2>
            </div>
            <div className="carousel-container">
                <Carousel responsive={responsive} rtl={true}>
                    {
                        props.data.map((item, i) => {
                            return (
                                <div className="product" key={i}>

                                    <div className={changeImage == i ? "image show" : "image hide"}>
                                        {props.title == "محصولات مشابه" &&
                                            <Link to={`/product/${item.code}`} style={{ color: "black" }}>
                                                <img className={changeImage == i ? "pro-image show" : "pro-image"} onMouseEnter={() => setChangeImage(i)} onMouseLeave={() => setChangeImage(null)} src={changeImage == i ? item.img[1] : item.img[0]} alt="" />
                                            </Link>
                                        }
                                        {props.title !== "محصولات مشابه" &&
                                            <img className={changeImage == i ? "pro-image show" : "pro-image"} onMouseEnter={() => setChangeImage(i)} onMouseLeave={() => setChangeImage(null)} src={changeImage == i ? item.img[1] : item.img[0]} alt="" />
                                        }
                                        {props.title !== "محصولات مشابه" &&
                                            <button onClick={() => {
                                                handleShowDetail(item)
                                                setShowdetail(true)
                                            }}>نمایش سریع</button>
                                        }
                                    </div>
                                    <div className="info">
                                        <Link to={`/product/${item.productCode}`} style={{ color: "black" }}>
                                            <div className="pro-brand"><span style={{ fontSize: "10px", color: "gray" }}>وست</span></div>
                                            <div className="name"><span>{item.title}</span></div>
                                            <div className="price">
                                                <span><CurrencyFormat
                                                    thousandSeparator={true}
                                                    value={item.price}
                                                    prefix="تومان"
                                                    displayType="text"></CurrencyFormat></span>
                                            </div>
                                            <div className="sizes">
                                                <p style={{ fontSize: "10px" }}>سایز ها :</p>
                                                {
                                                    item.sizes.map((elem, i) => {
                                                        return (
                                                            <span className={item.instock[i] == 0 ? "size-none" : ""} key={i}>{elem}</span>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            )
                        })
                    }
                </Carousel>
            </div>
            <Detailpro />
        </div>
    )
}

export default Carousel1